import { useMemo } from "react";
import { useProducts } from "../lib/useProducts";
import { useCart } from "../lib/cart";
import { ProductCard } from "./ProductCard";
import { Reveal, Eyebrow } from "./Reveal";
import { ChristmasSoon } from "./ChristmasSoon";

const CATS = ["All", "Desk accessories", "Gaming gear", "Toys", "Personalised gifts", "Christmas"];

export const Shop = ({ category, setCategory, onOpen }) => {
  const { data, isLoading, isError } = useProducts();
  const { add } = useCart();
  const products = Array.isArray(data) ? data : [];
  const shown = useMemo(() => (category === "All" ? products : products.filter((p) => p.category === category)), [products, category]);
  const quickAdd = (p) => {
    add(p, p.colors?.[0] || null);
  };

  return (
    <section id="shop" data-testid="shop-section" className="px-4 sm:px-8 py-16 sm:py-28 bg-white border-y-2 border-[var(--ink)]">
      <div className="max-w-7xl mx-auto">
        <Reveal className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 sm:gap-8 mb-8 sm:mb-12">
          <div>
            <Eyebrow color="var(--cyan)">The shop</Eyebrow>
            <h2 className="font-display font-extrabold tracking-tight text-4xl sm:text-5xl lg:text-6xl mt-5 leading-[0.95]">
              Ready-made <span className="font-serif-i font-normal">prints</span>
            </h2>
          </div>
          <div className="flex gap-2 overflow-x-auto -mx-4 px-4 pb-2 sm:flex-wrap sm:overflow-visible sm:mx-0 sm:px-0 sm:pb-0 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden" data-testid="shop-category-filters" data-lenis-prevent-horizontal>
            {CATS.map((c) => (
              <button key={c} data-testid={`filter-${c.toLowerCase().replace(/\s+/g, "-")}`} onClick={() => setCategory(c)}
                className={`shrink-0 whitespace-nowrap px-4 py-2.5 rounded-full border-2 border-[var(--ink)] font-semibold text-sm transition-colors ${category === c ? "bg-[var(--ink)] text-[var(--paper)]" : "bg-[var(--paper)] hover:bg-[var(--yellow)] hover:text-[var(--ink)]"}`}>
                {c === "Christmas" ? (
                  <span className="flex items-center gap-1.5">Christmas <span className="px-1.5 py-0.5 rounded-full bg-[#c8102e] text-white text-[11px] font-bold leading-none">SOON</span></span>
                ) : c}
              </button>
            ))}
          </div>
        </Reveal>
        {isLoading && <p className="font-mono-x" data-testid="shop-loading">Warming up the nozzle...</p>}
        {isError && <p className="font-mono-x" data-testid="shop-error">Couldn't load products right now. Please try again soon.</p>}
        {!isLoading && !isError && shown.length === 0 && (category === "Christmas" ? <ChristmasSoon /> : (
          <p className="font-display text-2xl" data-testid="shop-empty">Nothing here yet. Ask us about a custom print!</p>
        ))}
        <div className="grid grid-cols-2 lg:grid-cols-3 gap-x-3 sm:gap-x-6 gap-y-8 sm:gap-y-12">
          {shown.map((p, i) => <ProductCard key={p.slug} p={p} i={i} onOpen={onOpen} onAdd={quickAdd} />)}
        </div>
      </div>
    </section>
  );
};
